import React from 'react';
import {EqualColumns, Input, Select, Button} from 'ui-kit';

import * as styles from './BenefitForm.module.css';

export function BenefitForm({kind, quantity, name, onChange, onDelete}) {
  return (
    <div className={styles.Container}>
      <div className={styles.Fields}>
        <EqualColumns columns={3}>
          <Select
            label="Benefit type"
            value={kind}
            onChange={event => onChange('kind', event.target.value)}
          >
            <option value="cleaning">Cleaning</option>
            <option value="custom">Custom</option>
          </Select>
          <Input
            name="name"
            value={name}
            label="Benefit name"
            onChange={event => onChange('name', event.target.value)}
            noPadding
          />
          <Input
            name="quantity"
            value={quantity}
            label="Quantity per year"
            onChange={event => onChange('quantity', event.target.value)}
            noPadding
          />
        </EqualColumns>
      </div>
      <div className={styles.Button}>
        <Button size="small" color="light" type="button" onClick={onDelete}>
          Delete
        </Button>
      </div>
    </div>
  );
}
